/* eslint-disable react/no-unused-state */
import RenderTextField from '@app/components/Layout/Shares/FormHelpers/TextField';
import validate from './validate';
import { ScModalFinalForm, ScField } from '@app/components/Base/ScFinalForm';

const OrganizationModal = ({ isShow, onSave, onCloseModal }) => {
    const handleSubmitForm = (data) => {
        onSave?.(data);
    };

    return (
        <ScModalFinalForm
            title="Kết nối đơn vị"
            open={isShow}
            onClose={onCloseModal}
            onSubmit={handleSubmitForm}
            validate={validate}
        >
            <div className="row">
                <div className="col-md-12">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="form-group">
                                <ScField
                                    name="o_securitycode"
                                    className="form-control"
                                    label="Mã bảo mật"
                                    component={RenderTextField}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </ScModalFinalForm>
    );
};

export default OrganizationModal;
